import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.contract',
    method: 'get',
    params,
  })
}

export const listByCustomer = (params?: any) => {
  return axiosService({
    url: '/api.contract/customer',
    method: 'get',
    params,
  })
}

export const listAllByDirector = (params?: any) => {
  return axiosService({
    url: '/api.contract/all',
    method: 'get',
    params,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.contract/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.contract/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.contract/${id}`,
    method: 'put',
    data,
  })
}

export const reject = (id: number, data: any) => {
  return axiosService({
    url: `/api.contract/${id}/reject`,
    method: 'put',
    data,
  })
}

export const remake = (id: number, data: any) => {
  return axiosService({
    url: `/api.contract/${id}/remake`,
    method: 'put',
    data,
  })
}

export const approve = (id: number) => {
  return axiosService({
    url: `/api.contract/${id}/approve`,
    method: 'put',
    data: {},
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.contract/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.contract',
    method: 'post',
    data,
  })
}
